'use client'
import { useEffect, useState } from "react";
import { useContainerQuery } from "react-container-query";
import { containerBreakpoints as responsiveVariants_js_containerBreakpoints } from "../variants/interactions/responsiveVariants.js";
function computeBreakpoints(width) {
    const entries = Object.entries(responsiveVariants_js_containerBreakpoints);
    const result = entries.reduce((acc, [key, min])=>{
        acc[key] = width >= min;
        return acc;
    }, {});
    return {
        width,
        ...result
    };
}
const containerQuery = Object.entries(responsiveVariants_js_containerBreakpoints).reduce((acc, [key, minWidth])=>{
    acc[key] = {
        minWidth
    };
    return acc;
}, {});
function useContainerBreakpoints() {
    const [size, setSize] = useState({
        width: 0,
        height: 0
    });
    const [params, containerRef] = useContainerQuery(containerQuery, size);
    const [width, setWidth] = useState(0);
    useEffect(()=>{
        const element = containerRef.current;
        if (!element) return;
        const resizeObserver = new ResizeObserver((entries)=>{
            if (entries[0]) {
                const newWidth = entries[0].contentRect.width;
                const newHeight = entries[0].contentRect.height;
                setWidth(newWidth);
                setSize({
                    width: newWidth,
                    height: newHeight
                });
            }
        });
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerRef
    ]);
    const computed = computeBreakpoints(width);
    const containerBreakpoints = {
        ...computed,
        '3xs': params['3xs'] ?? computed['3xs'],
        '2xs': params['2xs'] ?? computed['2xs'],
        xs: params.xs ?? computed.xs,
        sm: params.sm ?? computed.sm,
        md: params.md ?? computed.md,
        lg: params.lg ?? computed.lg,
        xl: params.xl ?? computed.xl,
        '2xl': params['2xl'] ?? computed['2xl'],
        '3xl': params['3xl'] ?? computed['3xl'],
        '4xl': params['4xl'] ?? computed['4xl'],
        '5xl': params['5xl'] ?? computed['5xl'],
        '6xl': params['6xl'] ?? computed['6xl'],
        '7xl': params['7xl'] ?? computed['7xl']
    };
    return {
        ...containerBreakpoints,
        containerRef
    };
}
export { useContainerBreakpoints };
